import React from 'react'

const AdminDropDown = ({item,onSelect,renderRow}) => {
  return (
    <div className='typeDiv' onClick={()=>onSelect(item)}>
        {renderRow ? renderRow(item) :item?.value}
    </div>
  )
}

export default AdminDropDown;